export const promoBannersFileFormatsMultiSelectTranslationKeys = {
  promoFormatLabel: 'promo.format-label',
}
